import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Alert } from '../../models/alert.interface';
import { AlertType } from '../../enums/alertType.enum';
import { UtilService } from '../../util.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-alerts',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css'],
})
export class AlertsComponent implements OnInit, OnDestroy {
  destroy$: Subject<null> = new Subject();
  @Input() float = true;
  @Input() scrollToSubject = new Subject();

  constructor(private utilService: UtilService) {}

  _alerts: Alert[] = [];

  get alerts(): Alert[] {
    return this._alerts;
  }

  @Input() set alerts(alerts: Alert[]) {
    this._alerts = alerts;
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }

  ngOnInit(): void {
    this.scrollToSubject.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.utilService.scrollToId('alerts-container');
    });
  }

  onClose(alert: Alert) {
    const index = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
  }
}
